import React from "react";
import { twClassNames } from "../helpers/twClassNames";
import { uniqueId } from "lodash";

interface RadioButtonProps {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    checked?: boolean;
    label?: string | React.ReactNode;
    className?: string;
    labelClassName?: string;
}

export default function RadioButton({
    onChange,
    checked,
    label,
    className,
    labelClassName,
    ...props
}: RadioButtonProps & React.InputHTMLAttributes<HTMLInputElement>) {
    const id = uniqueId();

    return (
        <div className={twClassNames("radioContainer group", className)}>
            <input type="radio" id={id} checked={checked} onChange={onChange} {...props} />
            {label && (
                <label htmlFor={id} className={labelClassName}>
                    <span>{label}</span>
                </label>
            )}
        </div>
    );
}
